import { isVisibleComponetBaseOnRole } from "@/commons/RoleFunction.ts";
import { FluentProvider } from "@/dependencies";
import {
  Button,
  ButtonProps,
  makeStyles,
  mergeClasses
} from "@fluentui/react-components";

interface ButtonCustomProps {
  rcName?: string;
  theme?: string;
  rcRole?: string[];
  requireRoles?: string[];
  isIconButton?: boolean;
  isUseFluentProvider?: boolean;
  requireOwner?: boolean;
  isOwner?: boolean;
  isNotIconColor?: boolean;
}

const useStyles = makeStyles({
  root: {
    minWidth: "80px",
    fontWeight: "normal",
    //padding: "0px 8px"
  },
  svgColor: {
    "& svg": {
      color: "var(--colorCompoundBrandBackground)",
    },
  },
  root2: {
    minWidth: "10px",
  },
  disabled: {
    "& svg": {
      opacity: 0.5,
    },
  },
});

const ButtonCustom = (props: ButtonCustomProps & ButtonProps) => {
  const styles = useStyles();
  const isCanBeVisible = isVisibleComponetBaseOnRole(
    props.rcRole,
    props.requireRoles,
  ) && (props.requireOwner ? props.isOwner : true);
  return isCanBeVisible ? (
    props.isUseFluentProvider ? (
      <FluentProvider
        theme={
          props.theme
        }
      >
        <Button
          {...props}
          className={mergeClasses(
            props.isIconButton ? styles.root2 : styles.root,
            props.isNotIconColor ? "" : styles.svgColor,
            props.disabled ? styles.disabled : "",
            props.className,
          )}
        />
      </FluentProvider>
    ) : (
      <Button
        {...props}
        className={mergeClasses(
          props.isIconButton ? styles.root2 : styles.root,
          props.isNotIconColor ? "" : styles.svgColor,
          props.disabled ? styles.disabled : "",
          props.className,
        )}
      />
    )
  ) : null;
};

export default ButtonCustom;
